export const AB_POPUP_SERVICES_ID = [
    1150, 1100, 1083, 1066, 1149, 1108, 1129, 1055, 1023, 1060, 1150, 1135, 1185, 1037, 1035, 1002, 1003, 1041, 1112, 1168, 1021, 1050,
    1106, 1103,
];

export const AB_POPUP_EXT_SERVICES_NAMES = ['teksciory.interia.pl', 'tipy.interia.pl'];
